module.exports = __webpack_public_path__ + "static/img/icon-brand.7e430c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/icon-brand.png
// module id = EaTJ
// module chunks = 156